import { endpointsMd } from "utils/metadata-split/constant";
import * as Yup from "yup";

export const table = {
  primaryData: [
    {
      title: "Delivery Start Date",
      value: "start_date_time",
      name: "date_time",
      width: "10%",
    },
    {
      title: "Delivery End Date",
      value: "end_date_time",
      name: "date_time",
      width: "10%",
    },
    {
      title: "Exam Name",
      value: "test_name",
      width: "10%",
    },
    {
      title: "Exam Model",
      value: "exam_model_name",
      width: "10%",
    },
    {
      title: "Delivery ID",
      value: "delivery_id",
    },
    {
      title: "Test ID",
      value: "test_id",
    },
    {
      title: "Batch",
      value: "batch_list",
      width: "10%",
    },
    {
      title: "Status",
      value: "status",
      width: "5%",
    },
    {
      title: "Actions",
      width: "5%",
    },
  ],
  secondaryData: [
    {
      title: "Academic Year",
      value: "academic_year_list",
    },
    {
      title: "Board",
      value: "board_list",
    },
    {
      title: "Class",
      value: "class_list",
    },
    {
      title: "Attendance",
      value: "attendance",
    },
    {
      title: "Jumbled",
      value: "is_jumble",
    },
    {
      title: "Warm-Up Delivery Id",
      value: "warm_up_delivery_id",
    },
    {
      title: "Exam Category",
      value: "exam_category",
    },
    {
      title: "Created User Name",
      value: "created_user_name",
    },
  ],
};

export const deliveryListtable = {
  primaryData: [
    {
      title: "Delivery Start Date",
      value: "start_date_time",
      name: "date_time",
      width: "20%",
    },
    {
      title: "Delivery End Date",
      value: "end_date_time",
      name: "date_time",
      width: "20%",
    },
    {
      title: "Exam Name",
      value: "test_name",
      width: "10%",
    },
    {
      title: "Exam Model",
      value: "exam_model_name",
      width: "11%",
    },
    {
      title: "Attendance",
      value: "attendance",
      width: "5%",
    },
    {
      title: "Jumbled",
      value: "is_jumble",
    },
    {
      title: "Show Result",
      value: "show_results",
      width: "12%",
    },
    {
      title: "Show hint",
      value: "show_hint",
      width: "12%",
    },
    {
      title: "Show Response Sheet",
      value: "show_response_sheet",
      width: "17%",
    },
    {
      title: "Show Revise now",
      value: "show_revise_now",
      width: "16%",
    },
    // {
    //   title: "Actions",
    //   width: "3%",
    // },
  
  ],
  secondaryData: [
    {
      title: "Academic Year",
      value: "academic_year_list",
    },
    {
      title: "Board",
      value: "board_list",
    },
    {
      title: "Class",
      value: "class_list",
    },
    {
      title: "Delivery ID",
      value: "delivery_id",
    },
    {
      title: "Test ID",
      value: "test_id",
    },
    {
      title: "Batch",
      value: "batch_list",
    },
    {
      title: "Exam Category",
      value: "exam_category",
    },
    {
      title: "Status",
      value: "status"
    },
    {
      title: "Created User Name",
      value: "created_user_name",
    },
  ],
};

export const mandatoryFields = (testType: string) => {
  const basicFields = [
    { id: "test_id" },
    { id: "label" },
    { id: "class_id" },
    { id: "academic_year_id" },
    { id: "reservation_status_id" },
    { id: "batch_id" },
    { id: "sub_batch_id" },
  ];
  return testType === "Scheduled Tests"
    ? [
        ...basicFields,
        { id: "start_date_time" },
        { id: "end_date_time" },
        { id: "is_jumble" },
        { id: "attendance" },
        { id: "show_hint" },
        { id: "show_results" },
        { id: "show_response_sheet" },
        { id: "show_revise_now" },
      ]
    : basicFields;
};

export type createDeliveryTypes = {
  test_id: string;
  label: string;
  start_date_time?: string | undefined;
  end_date_time?: string | undefined;
  is_jumble: string;
  attendance: string;
  academic_year_id: string;
  reservation_status_id: string;
  class_id: string;
  batch_id: string;
  sub_batch_id: string;
  state_object_id: string[];
  district_id: string;
  college_object_id: string;
  board_id: string;
  ntse_exam_object_id: any;
  naps_level_list: any;
  delivery_type_object_id: any;
  warm_up_delivery_id: any;
  show_hint: string;
  show_results: string;
  show_response_sheet: string;
  show_revise_now: string;
};

export const createDeliveryInitialValues: createDeliveryTypes = {
  test_id: "",
  label: "",
  // start_date_time: undefined,
  // end_date_time: undefined,
  is_jumble: "",
  attendance: "",
  academic_year_id: "",
  reservation_status_id: "",
  class_id: "",
  batch_id: "",
  sub_batch_id: "",
  state_object_id: [],
  district_id: "",
  college_object_id: "",
  board_id: "",
  ntse_exam_object_id: "",
  naps_level_list: "",
  delivery_type_object_id: "",
  warm_up_delivery_id: "",
  show_hint: "false",
  show_results: "true",
  show_response_sheet: "true",
  show_revise_now: "true",
};

export const createDeliveryValidationSchema = Yup.object().shape({
  test_id: Yup.string().required("value required"),
  label: Yup.string()
    .required("value required")
    .max(100, "The name is too long"),
  // start_date_time: Yup.date().required("value required"),
  // end_date_time: Yup.date().required("value required"),
  is_jumble: Yup.string().required("value required"),
  attendance: Yup.string().required("value required"),
  academic_year_id: Yup.array()
    .required("value required")
    .min(1, "value required"),
  reservation_status_id: Yup.array()
    .min(1, "value required")
    .required("value required"),
  // reservation_status_id:Yup.array().of(Yup.string()).required("value required"),
  class_id: Yup.array().min(1, "value required").required("value required"),
  batch_id: Yup.array().min(1, "value required").required("value required"),
  sub_batch_id: Yup.array().min(1, "value required").required("value required"),
  show_hint: Yup.string().required("value required"),
  show_results: Yup.string().required("value required"),  
  show_response_sheet: Yup.string().required("value required"),   
  show_revise_now: Yup.string().required("value required"),   
});

export const createDeliveryTitle = [
  {
    id: "test_id",
    type: "text",
    label: "Enter Test ID",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },
  {
    id: "label",
    type: "text",
    label: "Enter Delivery Name",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },
  {
    id: "warm_up_delivery_id",
    type: "text",
    label: "Warm-Up Delivery Id",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
  },
  {
    id: "test_type",
    type: "text",
    label: "Test Type",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    disabled: true,
  },
];

export const createDeliveryTestTitle = [
  {
    id: "test_name",
    type: "text",
    label: "Test Name",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
    disabled: true,
  },
  {
    id: "test_id",
    type: "text",
    label: "Test ID",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
    disabled: true,
  },
  {
    id: "label",
    type: "text",
    label: "Enter Delivery Name",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    required: true,
  },
  {
    id: "warm_up_delivery_id",
    type: "text",
    label: "Warm-Up Delivery Id",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
  },
  {
    id: "test_type",
    type: "text",
    label: "Test Type",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
    disabled: true,
  },
];

export const createDeliveryProperties = (testType) => {
  const path = window.location.pathname;
  const editDelivery = path.includes("edit") || path.includes("duplicate");
  const isDisabled =
    testType !== "Scheduled Tests" && editDelivery ? true : false;
  const isRequiered = testType === "Scheduled Tests" ? true : false;
  return [
    {
      id: "start_date_time",
      type: "date-time-picker",
      label: "Start Date",
      className: "name-styles",
      required: isRequiered,
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      maxDateTime: "end_date_time",
      disabled: isDisabled,
    },
    {
      id: "end_date_time",
      type: "date-time-picker",
      label: "End Date",
      required: isRequiered,
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      minDateTime: "start_date_time",
      disabled: isDisabled,
    },
    {
      id: "is_jumble",
      type: "normal-select",
      label: testType === "Scheduled Tests" ? "Is Jumbled *" : "Is Jumbled",
      className: "select-styles",
      list: "jumble_status",
      required: isRequiered,
      onlyApiCall: true,
        requestList: async (payload) => {
          return {};
        },
      endpoint:endpointsMd.GET_JUMBLE_STATUS_LIST,
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      options: [],
      keyValue: { label: "jumble_status_name", value: "jumble_status_id" },
      //keyValue: { label: "name", value: "object_id" },
      disabled: isDisabled,
    },
    {
      id: "attendance",
      type: "normal-select",
      label: testType === "Scheduled Tests" ? "Attendance *" : "Attendance",
      list: "attendance_status",
      className: "select-styles",
      required: isRequiered,
      breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
      options: [],
      onlyApiCall: true,
        requestList: async (payload) => {
          return {};
        },
      endpoint:endpointsMd.GET_ATTENDANCE_STATUS_LIST,
      keyValue: { label: "attendance_status_name", value: "attendance_status_id" },
      //keyValue: { label: "name", value: "object_id" },
      disabled: isDisabled,
    },
    {
      id: "show_hint",
      type: "normal-select",
      label: "Show Hint",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
      options: [
        { label: "True", value: "true" },
        { label: "False", value: "false" },
      ],
      hideNone:true
    },
    {
      id: "show_results",
      type: "normal-select",
      label: "Show Result",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
      options: [
        { label: "True", value: "true" },
        { label: "False", value: "false" },
      ],
      hideNone:true
    },
    {
      id: "show_response_sheet",
      type: "normal-select",
      label: "Show Response Sheet",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
      options: [
        { label: "True", value: "true" },
        { label: "False", value: "false" },
      ],
      hideNone:true
    },
    {
      id: "show_revise_now",
      type: "normal-select",
      label: "Show Revise now",
      className: "select-styles",
      breakpoints: { xs: 12, sm: 6, md: 3, lg: 3 },
      options: [
        { label: "True", value: "true" },
        { label: "False", value: "false" },
      ],
      hideNone:true
    },
  ];
};

export const createBuildTestProperties = (disable = false)=>{
  return [
  {
    id: "academic_year_id",
    type: "multi-select",
    label: "Academic Year * ",
    className: "select-styles",
    required: true,
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "academic_year_list",
    keyValue: { label: "year_name", value: "year_id" },
   // keyValue: { label: "academic_year", value: "academic_year_id" },
    viewOnly: disable ? true : false,
  },
  {
    id: "reservation_status_id",
    type: "multi-select",
    label: "Registration Status *",
    required: true,
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "reservation_status_list",
    keyValue: { label: "registration_status_name", value: "registration_status_id" },
    //keyValue: { label: "reservation_status", value: "reservation_status_id" },
    viewOnly: disable ? true : false,
  },
  {
    id: "class_id",
    type: "multi-select-dependency",
    label: "Class *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    required: true,
    list: "class_course_batch_data",
    keyValue: { label: "class_name", value: "class_id" },
    dependentFields: ["batch_id", "sub_batch_id"],
    dependentFlds: {
      class_course_batch_data: "class_id",
      // batch_list: "batch_id",
    },
     viewOnly: disable ? true : false,
  },
  {
    id: "batch_id",
    type: "multi-select-dependency",
    label: "Batch *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    isDependent: true,
    options: [],
    required: true,
    list: "batch_list",
    dependencyLabel: "Please select Class",
    keyValue: { label: "batch_name", value: "batch_id" },
    fieldKeyLists: {
      // class_course_batch_data: "class_id",
    },
    dependentFields: ["sub_batch_id"],
    dependentFlds: {
     // class_course_batch_data: "class_id",
      batch_list: "batch_id",
      //sub_batch_list: "sub_batch_id",
    },
     viewOnly: disable ? true : false,
  },
  {
    id: "sub_batch_id",
    type: "multi-select-dependency",
    label: "Sub Batch *",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    isDependent: true,
    required: true,
    options: [],
    list: "sub_batch_list",
    dependencyLabel: "Please select Class & Batch",
    keyValue: { label: "sub_batch_name", value: "sub_batch_id" },
    fieldKeyLists: {
      // class_course_batch_data: "class_id",
      // batch_list: "batch_id",
    },
    dependentFlds: {
      // class_course_batch_data: "class_id",
      // batch_list: "batch_id",
      sub_batch_list: "sub_batch_id",
    },
    viewOnly: disable ? true : false,
  },
  {
    id: "state_id",
    type: "multi-select-dependency",
    label: "State",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "state_list",
    keyValue: { label: "state_name", value: "state_id" },
    dependentFields: ["college_id"],
    dependentFlds: {
      state_list: "state_id",
      //college_list: "college_id", 
    },
    viewOnly: disable ? true : false,
  },
  {
    id: "college_id",
    type: "multi-select-dependency",
    label: "College",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    isDependent: true,
    options: [],
    list: "college_list",
    dependencyLabel: "Please select State",
    keyValue: { label: "college_name", value: "college_id" },
    fieldKeyLists: {
      //state_list: "state_id",
    },
    viewOnly: disable ? true : false,
  },
  {
    id: "board_id",
    type: "multi-select-dependency",
    label: "Board",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    list: "board_list",
    keyValue: { label: "board_name", value: "board_id" },
    viewOnly: disable ? true : false,
  },
  {
    id: "ntse_exam_object_id",
    type: "normal-select",
    label: "NTSE Exam",
    className: "select-styles",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    list: "ntse_exam_list",
    onlyApiCall: true,
    requestList: async (payload) => {
      return {};
    },
    endpoint:endpointsMd.GET_NTSE_EXAM_LIST,
    keyValue: { label: "ntse_exam_name", value: "ntse_exam_id" },
    options: [],
    disabled: disable ? true : false,
    //keyValue: { label: "name", value: "object_id" },
  },
  {
    id: "cnaps_level_list",
    type: "multi-select",
    label: "CNAPS Level",
    className: "select-styles",
    list: "cnaps_level_list",
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    options: [],
    keyValue: { label: "cnaps_level_name", value: "cnaps_level_id" },
    //keyValue: { label: "name", value: "object_id" },
    viewOnly: disable ? true : false,
  },
  {
    id: "delivery_type_object_id",
    type: "normal-select",
    label: "Delivery Type",
    className: "select-styles",
    list: "delivery_type_list",
    onlyApiCall: true,
    requestList: async (payload) => {
      return {};
    },
    endpoint:endpointsMd.GET_DELIVERY_TYPE_LIST,
    breakpoints: { xs: 12, sm: 6, md: 4, lg: 3 },
    keyValue: { label: "delivery_type_name", value: "delivery_type_id" },
   // keyValue: { label: "name", value: "object_id" },
    disabled: disable ? true : false,
  },
  ]
}

// =======================================================

export const buildDeliveryCols = [
  "ID",
  "Delivery Start Date",
  "Delivery End Data",
  "Exam Name",
  "Exam Model",
  "Delivery ID",
  "Batch",
  "Statush",
  "Actions",
];

export interface buildDeliveryProps {
  test_id: string;
  start_date_time: string;
  end_date_time: string;
  test_name?: string;
  exam_model_name: string;
  delivery_id: string;
  status: string;
  actions: string;
  label: string;
}

// =======================================================

const subDays = (days) => {
  let date: any = new Date();
  date.setDate(date.getDate() - days);
  return date;
};

const initDateObj: any = {
  from: subDays(7),
  to: new Date(),
};

export const buildFormInitialValues: any = {
  start_date: initDateObj.from,
  end_date: initDateObj.to,
  exam_model_name: "",
  delivery_name: "",
  warm_up_delivery_id: "",
};

export const buildFormValidationSchema = Yup.object().shape({
  start_date: Yup.date().required("start date is required"),
  end_date: Yup.date().required("end date is required"),
  exam_model_name: Yup.array().required("exam model name is required"),
  delivery_name: Yup.string(),
  warm_up_delivery_id: Yup.string(),
});
